<template>
  <v-app>
    <v-app-bar
      app
      light
      elevation="10"
      :flat="true"
    >
      <div class="d-flex align-center toolbar-left">
        <div class="d-flex mr-6 align-center menu-button">
          <v-btn
            v-if="$auth.isAuthenticated"
            icon
            color="white"
            @click.stop="toggleMenu = !toggleMenu"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </div>

        <div class="d-flex">
          <router-link to="/authenticated/dashboard">
            <v-img
              alt="Aveine"
              class="shrink mt-1"
              contain
              min-width="135"
              src="@/assets/logo-aveine.png"
              width="100"
            />
          </router-link>
        </div>
      </div>

      <v-spacer class="mx-3"></v-spacer>

      <v-spacer v-if="!$auth.isAuthenticated"></v-spacer>
      
      <div v-if="$auth.loading" class="d-flex justify-center">
        <v-progress-circular
          indeterminate
          :size="25"
          :width="5"
          color="secondary"
      ></v-progress-circular>
      </div>
      <div v-else class="d-flex align-center">
        <div class="mb-1">
          <AveineButtonLanguage/>
        </div>
        <v-row v-if="$auth.isAuthenticated" class="user-profile">
          <span class="d-flex align-center font-weight-light mx-1">{{this.userProfile.name}}</span>
        </v-row>
        <AveineLogin/>
      </div>
    </v-app-bar>

    <v-main>
      <v-navigation-drawer
        class="menu-drawer"
        color="primary"
        dark
        v-model="toggleMenu"
        absolute
        temporary
        :elevation="1"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{$t("intranet.title.menu.navigation")}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item class="nav-links ml-6 mt-4">
            <router-link to="/authenticated/dashboard"><v-list-item-title>{{$t("intranet.title.menu.home")}}</v-list-item-title></router-link>
          </v-list-item>

          <!-- Vins. Retabli tel quel depuis f70cbf4, avant la simplification du
               menu : les quatre pages et leurs routes n'avaient pas bouge.
               `unchecked-wines` reste commente comme il l'etait a l'origine —
               ce n'est pas un oubli, l'API ne sert pas cette ressource
               (GET /unchecked-wines repond 404), le lien menerait a une page
               vide. -->
          <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    {{$t("intranet.title.menu.wines.title")}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item>
                        <router-link to="/authenticated/wines/list"><v-list-item-title>{{$t("intranet.title.menu.wines.list")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/wine-templates/list"><v-list-item-title>{{$t("intranet.title.menu.wines.wineTemplates")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/wine-forms/list"><v-list-item-title>{{$t("intranet.title.menu.wines.wineForms")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <!-- <v-list-item>
                        <router-link to="/authenticated/unchecked-wines/list"><v-list-item-title>{{$t("intranet.title.menu.wines.uncheckedWines")}}</v-list-item-title></router-link>
                      </v-list-item> -->
                      <v-list-item>
                        <router-link to="/authenticated/wine-comments/validate"><v-list-item-title>{{$t("intranet.title.menu.wines.commentValidation")}}</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    {{$t("intranet.title.menu.users.ambassador")}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item>
                        <router-link to="/authenticated/ambassadors/list"><v-list-item-title>{{$t("intranet.title.menu.users.ambassador")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/invoices"><v-list-item-title>{{$t("intranet.title.menu.users.invoice")}}</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>
           <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    Shopify
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item> 
                        <router-link to="/authenticated/orders/list"><v-list-item-title>{{$t("intranet.title.menu.shop.sales")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item> 
                        <router-link to="/authenticated/orders/stats"><v-list-item-title>{{$t("intranet.title.menu.shop.stats")}}</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>

          <!-- Contenu application. Les deux blocs permanents de la Home qui se
               pilotent depuis le back-office (REDMINE-12962). Volontairement
               a part de « Ressources Diverses » : ce ne sont pas des
               referentiels viticoles mais du contenu editorial, et les ranger
               a cote de Cepages et Regions laisserait croire le contraire. -->
          <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    {{$t("intranet.title.menu.home-content.title")}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item>
                        <router-link to="/authenticated/quizzes/list"><v-list-item-title>{{$t("intranet.title.menu.home-content.quiz")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/wines-of-the-month/list"><v-list-item-title>{{$t("intranet.title.menu.home-content.wineOfTheMonth")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <!-- Regions proposees dans le profil de gout (REDMINE-13656). -->
                      <v-list-item>
                        <router-link to="/authenticated/featured-regions/list"><v-list-item-title>{{$t("intranet.title.menu.home-content.featuredRegions")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <!-- Cepages proposes dans le profil de gout (REDMINE-13839). -->
                      <v-list-item>
                        <router-link to="/authenticated/featured-grapes/list"><v-list-item-title>{{$t("intranet.title.menu.home-content.featuredGrapes")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <!-- Signalements des contenus generes par l'IA (REDMINE-13560) :
                           la moderation de ce que l'app affiche, d'ou sa place ici. -->
                      <v-list-item>
                        <router-link to="/authenticated/ai-content-reports/list"><v-list-item-title>{{$t("intranet.title.menu.home-content.aiReports")}}</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>

          <!-- Abonnements (REDMINE-13522) : le catalogue des produits des stores
               et le journal de ce qu'ils envoient. Les abonnements d'un
               utilisateur se lisent sur sa fiche. -->
          <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    {{$t("intranet.title.menu.billing.title")}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item>
                        <router-link to="/authenticated/billing/products"><v-list-item-title>{{$t("intranet.title.menu.billing.products")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/billing/events"><v-list-item-title>{{$t("intranet.title.menu.billing.events")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/billing/grants"><v-list-item-title>{{$t("intranet.title.menu.billing.grants")}}</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>

          <!-- Ressources Diverses. Le groupe avait disparu du tiroir avec la
               simplification du menu (3e306ef), alors que ses quatre pages
               n'ont jamais ete supprimees : les routes, les vues et les paquets
               aveine-grape / -region / -appellation / -company sont restes en
               place, seuls les liens manquaient. Le groupe est donc retabli a
               l'identique, augmente des deux referentiels de degustation. -->
          <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    {{$t("intranet.title.menu.misc-ressources.title")}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item>
                        <router-link to="/authenticated/grapes/list"><v-list-item-title>{{$t("intranet.title.menu.misc-ressources.grape")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/regions/list"><v-list-item-title>{{$t("intranet.title.menu.misc-ressources.region")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/appellations/list"><v-list-item-title>{{$t("intranet.title.menu.misc-ressources.appellation")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/companies/list"><v-list-item-title>{{$t("intranet.title.menu.misc-ressources.company")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/aromas/list"><v-list-item-title>{{$t("intranet.title.menu.misc-ressources.aroma")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/food-pairings/list"><v-list-item-title>{{$t("intranet.title.menu.misc-ressources.foodPairing")}}</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>

          <!-- Gestion Tech. Dernier groupe retire par 3e306ef, retabli tel quel.
               Ses quatre pages sont vivantes : annonces, changelogs et
               aerateurs repondent 200 cote API, et la page Algolia declenche
               POST /algolia/synchronize/:type. -->
          <v-list-item>
            <v-list-item-content>
              <v-expansion-panels>
                <v-expansion-panel flat>
                  <v-expansion-panel-header hide-actions color="primary">
                    {{$t("intranet.title.menu.tech-management.title")}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="primary">
                    <v-list dense>
                      <v-list-item>
                        <router-link to="/authenticated/announcements/list"><v-list-item-title>{{$t("intranet.title.menu.tech-management.announcements")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/changelogs/list"><v-list-item-title>{{$t("intranet.title.menu.tech-management.changelogs")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/aerators/list"><v-list-item-title>{{$t("intranet.title.menu.tech-management.aerators")}}</v-list-item-title></router-link>
                      </v-list-item>
                      <v-list-item>
                        <router-link to="/authenticated/algolia"><v-list-item-title>Algolia</v-list-item-title></router-link>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-container v-if="loadRoute" fluid class="app-container">
        <router-view :key="$route.fullPath"/>
      </v-container>
    </v-main>
    <v-footer    
      fixed
      dark
      color="primary"
      :elevation="10"
      class="d-flex flex-column justify-center"
    >
      <v-col
        class="text-center text-caption"
      >
        <b>Version {{require('../package.json').version}} Copyright © {{ new Date().getFullYear() }} Aveine.</b>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { headers } from './store/index'
import { AveineButtonLanguage, AveineLogin } from 'aveine-toolbox/src/wrapper'
import { errorHandler } from 'aveine-toolbox'

export default {
  name: 'App',

  components: {
    AveineButtonLanguage,
    AveineLogin
  },
  data: () => ({
    toggleMenu: false,
    profileFormIsValid: false,
    userProfile: {},
    loadRoute: false,
    APIbaseURL: process.env.VUE_APP_API_HOST
  }),
  methods: {
    async checkAuth(loading) {
      this.$auth.instantiateAuthClient();
      if (loading === false) {
        const token = this.$auth.getTokenSilently();
        if (this.$auth.isAuthenticated || token != undefined) {
          try {
            headers["Authorization"] = `Bearer ` + token;
            headers["Content-Type"] = 'application/vnd.api+json'

            this.loadRoute = true

            // Le tableau de bord n'est que la porte d'entree : depuis la page de
            // connexion (`/`, `/login`). Une page deja dans l'espace connecte
            // reste ou elle est, sinon chaque rafraichissement y ramenait.
            // `window.location` et non `this.$route` : au premier chargement, la
            // navigation initiale attend encore le garde d'authentification, et
            // `$route` vaut toujours `/`.
            if (!window.location.pathname.startsWith("/authenticated")) {
              this.$router.push("/authenticated/dashboard")
            }
          } catch (errors) {
            errorHandler(errors, this)
          }
        } else {
          this.loadRoute = true
        }
      }
    }
  },
  async created() {
    this.$auth.$watch('authRedirect', async () => {
      this.checkAuth(this.$auth.loading);
    });

    this.checkAuth(this.$auth.loading);
  },
};
</script>

<style lang="scss">
  
  @import "aveine-toolbox/src/assets/style/aveine-style";
  @import "aveine-toolbox/src/assets/style/aveine-font";
  
  html,body{
    overflow-x: hidden;
  }
  
  div.app-container {
    padding: 0 !important;
  }

  div.language-button-wrapper {
    width: 45px
  }

  div.menu-button {
    background-color: var(--v-primary-base);
  }

  div.v-toolbar__content {
    padding-left: 0 !important;
    div.toolbar-left {
      height: inherit;
      div.menu-button {
        height: inherit;
      }
    }
  }

  div.image-upload {
    p {
      margin-top: 5px;
    }

    div.upload-btn-wrapper {
      position: relative;
      overflow: hidden;
      display: inline-block;
    }

    button.btn {
      background: #FFFFFF;
      border: 1px solid #a3a3a3;
      border-radius: 5px;
      padding: 5px 25px 5px 25px;
    }

    div.upload-btn-wrapper input[type=file] {
      font-size: 100px;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }

  aside.menu-drawer {
    position: fixed;
    top: 65px !important;
    border-radius: 0px 50px 0px 0px;
    div.v-list--dense {
      margin-bottom: 8vh;
    }
    div.nav-links {
      a {
        div.v-list-item__title {
          font-size: 0.9375rem !important;
          line-height: 1;
        }
      }
      margin-bottom: 10px;
      min-height: 40px;
    }
    div.v-list-item__title {
      color: white !important;
      text-decoration: none;
    }
  }

  .avatar-image-preview {
    width: 20vw;
  }
</style>